<template>
  <div class="card p-shadow-app">
    <h1>Equipamentos</h1>
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <ConfirmDialog></ConfirmDialog>
    <div style="height: 75vh">
      <DataTable
        :value="equipmentsList"
        :selection.sync="selectedEquipments"
        dataKey="id"
        :filters.sync="filters"
        filterDisplay="row"
        :loading="loading"
        class="p-datatable-sm"
        stripedRows
        sortMode="single"
        responsiveLayout="scroll"
        :scrollable="true"
        scrollHeight="flex"
        :paginator="true"
        :rows="perPage"
        :rowsPerPageOptions="[10, 25, 50, 100]"
        :lazy="true"
        :totalRecords="totalRecords"
        @filter="loadEquipments"
        @sort="loadEquipments"
        @page="loadEquipments"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Mostrar de {first} a {last} de {totalRecords} dados"
      >
        <template #empty> Nada a mostrar </template>
        <template #loading> A carregar. Por favor Aguarde... </template>
        <template #header>
          <div class="table-header">
            <Button
              icon="pi pi-plus"
              @click="addNew"
              class="p-mr-1"
              v-if="can('createUpdateParts')"
            />
            <Button
              icon="pi pi-sync"
              v-tooltip="'Sincronizar Produtos com Loja'"
              @click="syncToStore"
              v-if="can('syncProductsStore')"
            />
            <Button
              class="p-ml-1"
              icon="pi pi-images"
              v-tooltip="'Sincronizar Imagens dos equipamentos com a Loja'"
              @click="syncImagesToStore"
              v-if="can('syncProductsStore')"
            />
            <Button
              class="p-ml-1"
              icon="pi pi-file-excel"
              v-tooltip="'Importar Equipamentos via CSV'"
              @click="openCsvImportDialog"
              v-if="can('createUpdateParts')"
            />
            <Button
              class="p-ml-1"
              icon="pi pi-cloud-upload"
              label="Importar imagens"
              v-tooltip="'Importar imagens de equipamentos ou produtos'"
              @click="bulkImageManager.show = true"
              v-if="can('createUpdateParts')"
            />
            <span
              v-if="csvImportBatch.status"
              class="csv-import-status p-ml-2"
              :class="csvImportBatchStatusClass"
              v-tooltip="'Clique para atualizar o estado da importação LG'"
              @click="loadCsvImportBatchStatus"
            >
              <i
                class="pi p-mr-1"
                :class="csvImportBatch.status.cancelled ? 'pi-ban' : (csvImportBatch.status.finished ? (csvImportBatch.status.failed_jobs > 0 ? 'pi-exclamation-triangle' : 'pi-check-circle') : 'pi-spin pi-spinner')"
              ></i>
              {{ csvImportBatchStatusLabel }}
            </span>
            <Button
              v-if="csvImportBatchActive && can('createUpdateParts')"
              icon="pi pi-stop-circle"
              class="p-button-danger p-button-sm p-ml-1"
              v-tooltip="'Cancelar importação LG'"
              :loading="csvImportBatch.cancelling"
              @click="confirmCancelCsvImportBatch"
            />
            <span
              v-if="bulkDeleteBatch.status"
              class="bulk-delete-status p-ml-2"
              :class="bulkDeleteBatchStatusClass"
              v-tooltip="'Clique para atualizar o estado da eliminação'"
              @click="loadBulkDeleteBatchStatus"
            >
              <i
                class="pi p-mr-1"
                :class="bulkDeleteBatch.status.cancelled ? 'pi-ban' : (bulkDeleteBatch.status.finished ? (bulkDeleteBatch.status.failed_jobs > 0 ? 'pi-exclamation-triangle' : 'pi-check-circle') : 'pi-spin pi-spinner')"
              ></i>
              {{ bulkDeleteBatchStatusLabel }}
            </span>
            <Button
              v-if="bulkDeleteBatchActive && can('createUpdateParts')"
              icon="pi pi-stop-circle"
              class="p-button-danger p-button-sm p-ml-1"
              v-tooltip="'Cancelar eliminação em lote'"
              :loading="bulkDeleteBatch.cancelling"
              @click="confirmCancelBulkDeleteBatch"
            />
            <Button
              icon="pi pi-trash"
              class="p-button-danger p-ml-1"
              :label="'Eliminar (' + selectedEquipments.length + ')'"
              v-tooltip="'Eliminar Equipamentos Selecionados'"
              @click="confirmBulkDelete"
              :disabled="bulkDeleteBatchActive"
              v-if="can('createUpdateParts') && selectedEquipments.length > 0"
            />
          </div>
        </template>
        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }"></Column>
        <Column :headerStyle="{ width: '10rem' }" :bodyStyle="{ 'text-align': 'center' }" header="Ações">
          <template #body="slotProps">
            <Button
              icon="pi pi-list"
              class="p-button-rounded p-button-text p-button-info"
              v-tooltip.top="'Ver Produtos'"
              @click="openProductsDialog(slotProps.data)"
            />
            <Button
              icon="pi pi-cloud-upload"
              class="p-button-rounded p-button-text p-button-success p-ml-1"
              v-tooltip.top="'Importar Produtos'"
              @click="openImportDialog(slotProps.data)"
              v-if="can('createUpdateParts') && slotProps.data.brand && slotProps.data.brand.name.toUpperCase() === 'LG'"
            />
            <Button
              icon="pi pi-trash"
              class="p-button-rounded p-button-text p-button-danger p-ml-1"
              v-tooltip.top="'Eliminar Equipamento'"
              @click="confirmDelete(slotProps.data)"
              v-if="can('createUpdateParts')"
            />
          </template>
        </Column>
        <Column
          field="api_id"
          header="Sinc. Loja"
          sortable
          :headerStyle="{ 'min-width': '9%', 'max-width': '9%' }"
          :filterHeaderStyle="{ 'min-width': '9%', 'max-width': '9%' }"
          :bodyStyle="{ 'min-width': '9%', 'max-width': '9%' }"
          :showFilterMenu="false"
        >
          <template #body="slotProps">
            <span
              class="clickable-item"
              @click="edit(slotProps.data)"
              v-if="can('createUpdateParts')"
            >
              <template v-if="slotProps.data.api_id != null">
                <i class="pi pi-check-circle text-green-500"></i>
              </template>
              <template v-else>
                <i class="pi pi-times-circle text-red-400"></i>
              </template>
            </span>
            <span v-else>
              <template v-if="slotProps.data.api_id != null">
                <i class="pi pi-check-circle text-green-500"></i>
              </template>
              <template v-else>
                <i class="pi pi-times-circle text-red-400"></i>
              </template>
            </span>
          </template>
          <template #filter>
            <Checkbox v-model="has_api_id"
              :indeterminate="has_api_id === null"
              :binary="true"
              @change="() => { loadEquipments({ page: 0 }); }" />
              <span v-if="has_api_id !== null" class="p-ml-3" @click="() => { has_api_id = null; loadEquipments({ page: 0 }); }">
                <i class="pi pi-times"></i>
              </span>
          </template>
        </Column>
        <Column
          field="brand_id"
          header="Marca"
          sortable
          filterField="brand_id"
          :headerStyle="{ 'min-width': '12%', 'max-width': '14%' }"
          :filterHeaderStyle="{ 'min-width': '12%', 'max-width': '14%' }"
          :bodyStyle="{ 'min-width': '12%', 'max-width': '14%' }"
        >
          <template #body="slotProps">
            <span
              class="clickable-item"
              @click="edit(slotProps.data)"
              v-if="can('createUpdateParts')"
            >
              {{ slotProps.data.brand.name ?? "_______" }}
            </span>
            <span v-else>
              {{ slotProps.data.brand.name ?? "" }}
            </span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <Dropdown
              v-model="filterModel.value"
              @input="filterCallback()"
              :options="brandsList"
              optionValue="id"
              optionLabel="name"
              class="p-column-filter"
              :showClear="true"
            >
            </Dropdown>
          </template>
        </Column>
        <Column
          field="supplier_id"
          header="Fornecedor"
          sortable
          filterField="supplier_id"
          :headerStyle="{ 'min-width': '12%', 'max-width': '14%' }"
          :filterHeaderStyle="{ 'min-width': '12%', 'max-width': '14%' }"
          :bodyStyle="{ 'min-width': '12%', 'max-width': '14%' }"
        >
          <template #body="slotProps">
            <span
              class="clickable-item"
              @click="edit(slotProps.data)"
              v-if="can('createUpdateParts')"
            >
              {{ slotProps.data.supplier.name ?? "_______" }}
            </span>
            <span v-else>
              {{ slotProps.data.supplier.name ?? "" }}
            </span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <Dropdown
              v-model="filterModel.value"
              @input="filterCallback()"
              :options="suppliersList"
              optionValue="id"
              optionLabel="name"
              class="p-column-filter"
              :showClear="true"
            >
            </Dropdown>
          </template>
        </Column>
        <Column
          field="spares_category"
          header="Categoria"
          sortable
          filterField="category"
          :headerStyle="{ 'min-width': '12%', 'max-width': '14%' }"
          :filterHeaderStyle="{ 'min-width': '12%', 'max-width': '14%' }"
          :bodyStyle="{ 'min-width': '12%', 'max-width': '14%' }"
        >
          <template #body="slotProps">
            <span
              class="clickable-item"
              @click="edit(slotProps.data)"
              v-if="can('createUpdateParts')"
            >
              {{ slotProps.data.spares_category ? slotProps.data.spares_category.name : (slotProps.data.sparesCategory ? slotProps.data.sparesCategory.name : "_______") }}
            </span>
            <span v-else>
              {{ slotProps.data.spares_category ? slotProps.data.spares_category.name : (slotProps.data.sparesCategory ? slotProps.data.sparesCategory.name : "") }}
            </span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
            />
          </template>
        </Column>
        <Column
          field="model_code"
          filterField="model_code"
          header="Código do Modelo"
          sortable
          :headerStyle="{ 'min-width': '21%', 'max-width': '21%' }"
          :filterHeaderStyle="{ 'min-width': '21%', 'max-width': '21%' }"
          :bodyStyle="{ 'min-width': '21%', 'max-width': '21%' }"
        >
          <template #body="slotProps">
            <span
              class="clickable-item"
              @click="edit(slotProps.data)"
              v-if="can('createUpdateParts')"
            >
              {{ slotProps.data.model_code ?? "_______" }}
            </span>
            <span v-else>
              {{ slotProps.data.model_code ?? "" }}
            </span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column
          field="equipment_series"
          filterField="equipment_series"
          header="Série do Equipamento"
          sortable
          :headerStyle="{ 'min-width': '21%', 'max-width': '21%' }"
          :filterHeaderStyle="{ 'min-width': '21%', 'max-width': '21%' }"
          :bodyStyle="{ 'min-width': '21%', 'max-width': '21%' }"
        >
          <template #body="slotProps">
            <span
              class="clickable-item"
              @click="edit(slotProps.data)"
              v-if="can('createUpdateParts')"
            >
              {{ slotProps.data.equipment_series ?? "_______" }}
            </span>
            <span v-else>
              {{ slotProps.data.equipment_series ?? "" }}
            </span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column
          field="description"
          filterField="description"
          header="Descrição"
          sortable
          :headerStyle="{ 'min-width': '15%', 'max-width': '15%' }"
          :filterHeaderStyle="{ 'min-width': '15%', 'max-width': '15%' }"
          :bodyStyle="{ 'min-width': '15%', 'max-width': '15%' }"
        >
          <template #body="slotProps">
            <span
              class="clickable-item"
              @click="edit(slotProps.data)"
              v-if="can('createUpdateParts')"
            >
              {{ slotProps.data.description ?? "_______" }}
            </span>
            <span v-else>
              {{ slotProps.data.description ?? "" }}
            </span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column
          field="active"
          header="Ativo"
          sortable
          filterField="active"
          :headerStyle="{ 'min-width': '10%', 'max-width': '10%' }"
          :filterHeaderStyle="{ 'min-width': '10%', 'max-width': '10%' }"
          :bodyStyle="{ 'min-width': '10%', 'max-width': '10%' }"
        >
          <template #body="slotProps">
            {{ slotProps.data.active == 1 ? "Sim" : "Não" }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <Dropdown
              v-model="filterModel.value"
              @input="filterCallback()"
              :options="[
                { value: 0, label: 'Não' },
                { value: 1, label: 'Sim' },
              ]"
              optionValue="value"
              optionLabel="label"
              class="p-column-filter"
              :showClear="true"
            >
            </Dropdown>
          </template>
        </Column>
      </DataTable>
    </div>
    <Dialog
      :visible.sync="form.show"
      :containerStyle="{ width: $isMobile() ? '100vw' : '40vw' }"
      :maximizable="true"
      :modal="true"
      v-on:hide="hideForm"
      v-on:show="
        () => {
          $validator.resume();
        }
      "
      :header="form.id ? 'Editar Equipamento' : 'Novo Equipamento'"
    >
      <Loading
        :active.sync="loading"
        :isFullPage="false"
        :zIndex="9000"
      ></Loading>
      <form class="p-col-12" @submit.prevent="save" style="min-height: 60vh">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-12 p-mt-2">
            <span
              class="p-float-label"
              style="top: -0.75rem; left: -1rem; font-size: 12px"
            >
              <label for="active">Ativa</label>
            </span>
            <InputSwitch
              v-model="form.active"
              :name="'active'"
              :id="'active'"
              style="'top: 4px;"
            />
          </div>
          <div class="p-field p-col-12 p-md-6 p-mt-3">
            <span class="p-float-label">
              <Dropdown
                :name="'supplier'"
                :id="'supplier'"
                :filter="true"
                :showClear="true"
                v-model="form.supplier_id"
                :options="suppliersList"
                optionLabel="name"
                optionValue="id"
                v-validate="'required'"
                dataKey="id"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('supplier'),
                  },
                  'form-control',
                ]"
              />
              <label for="supplier">Fornecedor</label>
            </span>
            <small v-if="errors.has('supplier')" class="p-error" role="alert">
              Fornecedor é obrigatório
            </small>
          </div>
          <div class="p-field p-col-12 p-md-6 p-mt-3">
            <span class="p-float-label">
              <Dropdown
                :name="'brand'"
                :id="'brand'"
                :filter="true"
                :showClear="true"
                v-model="form.brand_id"
                :options="brandsList"
                optionLabel="name"
                optionValue="id"
                v-validate="'required'"
                dataKey="id"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('brand'),
                  },
                  'form-control',
                ]"
              />
              <label for="brand">Marca</label>
            </span>
            <small v-if="errors.has('brand')" class="p-error" role="alert">
              Marca é obrigatória
            </small>
          </div>
          <div class="p-field p-col-12 p-md-6 p-mt-3">
            <span class="p-float-label">
              <InputText
                :id="'equipmentSerie'"
                :name="'equipmentSerie'"
                autocomplete="off"
                v-validate="'required'"
                v-model="form.equipment_series"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('equipmentSerie'),
                  },
                  'form-control',
                ]"
              />
              <label for="equipmentSerie">Série do Equipamento</label>
            </span>
            <small
              v-if="errors.has('equipmentSerie')"
              class="p-error"
              role="alert"
            >
              Série do Equipamento é obrigatório
            </small>
          </div>
          <div class="p-field p-col-12 p-md-6 p-mt-3">
            <span class="p-float-label">
              <InputText
                :id="'modelCode'"
                :name="'modelCode'"
                autocomplete="off"
                :disabled="form.id && form.data.products_count > 0"
                v-validate="'required'"
                v-model="form.model_code"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('modelCode'),
                  },
                  'form-control',
                ]"
              />
              <label for="modelCode">Código do Modelo</label>
            </span>
            <small v-if="errors.has('modelCode')" class="p-error" role="alert">
              Código do Modelo é obrigatório
            </small>
          </div>
          <div class="p-field p-col-12 p-md-6 p-mt-3">
            <span class="p-float-label">
              <InputText
                :id="'modelName'"
                :name="'modelName'"
                autocomplete="off"
                v-validate="'required'"
                v-model="form.model_name"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('modelName'),
                  },
                  'form-control',
                ]"
              />
              <label for="modelName">Nome do Modelo</label>
            </span>
            <small v-if="errors.has('modelName')" class="p-error" role="alert">
              Nome do Modelo é obrigatório
            </small>
          </div>
          <div class="p-field p-col-12 p-md-6 p-mt-3">
            <span class="p-float-label">
              <Textarea
                :id="'description'"
                :name="'description'"
                autocomplete="off"
                :autoResize="true"
                maxlength="150"
                rows="1"
                v-validate="'required'"
                v-model="form.description"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('description'),
                  },
                  'form-control',
                ]"
              />
              <label for="description">Descrição</label>
            </span>
            <small
              v-if="errors.has('description')"
              class="p-error"
              role="alert"
            >
              Descrição é obrigatório
            </small>
          </div>
          <div class="p-field p-col-12 p-md-6 p-mt-3">
            <label for="spares_category" style="font-size: 12px; color: #888; display: block; margin-bottom: 4px;">Categoria</label>
            <div class="p-inputgroup">
              <InputText
                id="spares_category"
                name="spares_category"
                :value="selectedCategoryName"
                :disabled="true"
                placeholder="Selecione uma categoria..."
              />
              <Button
                icon="pi pi-search"
                class="p-button-secondary"
                @click="showCategoryDialog"
                type="button"
                v-tooltip="'Escolher Categoria'"
              />
              <Button
                v-if="form.spares_category_id"
                icon="pi pi-times"
                class="p-button-danger"
                @click="clearSelectedCategory"
                type="button"
                v-tooltip="'Limpar Categoria'"
              />
            </div>
            <input type="hidden" name="spares_category_id" v-model="form.spares_category_id" v-validate="'required'" />
            <small v-if="errors.has('spares_category_id')" class="p-error" role="alert">
              Categoria é obrigatória
            </small>
          </div>
          <div
            class="p-field p-col-12 p-md-12 p-mt-2"
            v-if="
              form.data == undefined ||
              form.data.localization_parts_file.length == 0
            "
          >
            <FileUpload
              ref="imagesLocation"
              name="imagesLocation.files[]"
              id="imagesLocation.files"
              chooseLabel="Localização Peças"
              accept="image/gif,image/jpg,image/jpeg,image/pjpeg,image/png,image/x-png"
              invalidFileTypeMessage="Ficheiro inválido. Apenas aceita GIF, JPG, JPEG ou PNG"
              :previewWidth="100"
              :multiple="false"
              :fileLimit="1"
              :showUploadButton="false"
              :showCancelButton="false"
            >
              <template #empty>
                <div class="drag-drop-files">
                  <p>
                    Arraste a imagem da localização das peças do equipamento
                  </p>
                </div>
              </template>
            </FileUpload>
          </div>
          <div class="p-field p-col-12 p-md-12 p-mt-2" v-else>
            <h5>Localização das Peças</h5>
            <span
              v-for="file in form.data.localization_parts_file"
              :key="file.id"
              class="p-d-flex p-mb-2"
            >
              <span class="p-d-flex p-flex-wrap p-ai-center p-jc-center">
                <AuthenticatedImage
                    :file="file"
                    :alt="file.file_origin_name"
                    height="50"
                    class="p-mr-2"
                />
                <Button
                  icon="pi pi-trash"
                  class="p-button-sm p-button-danger"
                  @click="removeImage(file, 'localization')"
                />
              </span>
            </span>
          </div>
          <div
            class="p-field p-col-12 p-md-12 p-mt-2"
            v-if="form.data == undefined || form.data.images.length == 0"
          >
            <FileUpload
              ref="images"
              name="images.files[]"
              id="images.files"
              chooseLabel="Imagens do Equipamento"
              accept="image/gif,image/jpg,image/jpeg,image/pjpeg,image/png,image/x-png"
              invalidFileTypeMessage="Ficheiro inválido. Apenas aceita GIF, JPG, JPEG ou PNG"
              :previewWidth="100"
              :multiple="false"
              :fileLimit="1"
              :showUploadButton="false"
              :showCancelButton="false"
            >
              <template #empty>
                <div class="drag-drop-files">
                  <p>Arraste as imagens do equipamento</p>
                </div>
              </template>
            </FileUpload>
          </div>
          <div
            class="p-field p-col-12 p-md-12 p-mt-2"
            v-if="form.data && form.data.images && form.data.images.length"
          >
            <h5>Galeria de imagens</h5>
            <span
              v-for="(file, imageIndex) in form.data.images"
              :key="file.id"
              class="p-d-flex p-mb-2"
            >
            <span class="p-d-flex p-flex-wrap p-ai-center p-jc-center">
              <span class="p-mr-2" style="min-width: 5.5rem; font-size: 0.8rem; color: #6c757d;">
                {{ imageIndex === 0 ? "Principal" : `Posição ${imageIndex + 1}` }}
              </span>
              <AuthenticatedImage
                :file="file"
                :alt="file.file_origin_name"
                height="50"
                class="p-mr-2"
              />
              <Button
                icon="pi pi-trash"
                class="p-button-sm p-button-danger"
                @click="removeImage(file, 'photo')"
              />
            </span>
            </span>
          </div>
        </div>
      </form>
      <template #footer>
        <Button
          :label="'Guardar'"
          icon="pi pi-save"
          class="p-button-sm p-button-success"
          @click="save()"
        />
        <Button
          :label="'Cancelar'"
          icon="pi pi-times"
          class="p-button-sm p-button-danger"
          @click="hideForm()"
        />
      </template>
    </Dialog>
    <Dialog
      :visible.sync="categoryDialog.show"
      :containerStyle="{ width: $isMobile() ? '100vw' : '30vw' }"
      :modal="true"
      header="Selecionar Categoria"
    >
      <div style="max-height: 50vh; overflow-y: auto;">
        <Tree
          :value="categoriesTree"
          selectionMode="single"
          :selectionKeys.sync="categoryDialog.selectedKey"
          @node-select="onCategorySelect"
        >
          <template #default="slotProps">
            <span :class="{'category-node-selected': categoryDialog.tempSelectedNode && categoryDialog.tempSelectedNode.key === slotProps.node.key}" class="category-node">
              <span>{{ slotProps.node.label }}</span>
            </span>
          </template>
        </Tree>
      </div>
      <template #footer>
        <Button
          label="Confirmar"
          icon="pi pi-check"
          class="p-button-sm p-button-success"
          @click="confirmCategorySelection"
          :disabled="!categoryDialog.tempSelectedNode"
        />
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-sm p-button-danger"
          @click="categoryDialog.show = false"
        />
      </template>
    </Dialog>
    <EquipmentProductsDialog
      :visible.sync="productsDialog.show"
      :equipament="productsDialog.equipament"
    />
    <ImportProducts
      v-if="importDialog.equipament"
      :equipament="importDialog.equipament"
      :show="importDialog.show"
      @cancel="importDialog.show = false"
    />
    <BulkImageManager :visible.sync="bulkImageManager.show" />
    <Dialog
      :visible.sync="csvImportDialog.show"
      :containerStyle="{ width: $isMobile() ? '100vw' : '40vw' }"
      :modal="true"
      header="Importar Equipamentos via CSV"
    >
      <Loading
        :active.sync="csvImportDialog.loading"
        :isFullPage="false"
        :zIndex="9000"
      ></Loading>
      <div class="p-fluid">
        <p class="p-mb-3" style="color: #6c757d; font-size: 0.95rem;">
          Selecione o ficheiro CSV para importar modelos de equipamentos. O separador pode ser ponto e vírgula (;) ou vírgula (,).
        </p>
        <FileUpload
          ref="csvFileUpload"
          name="file"
          chooseLabel="Selecionar Ficheiro CSV"
          accept=".csv,text/csv,text/plain"
          :auto="false"
          :showUploadButton="false"
          :showCancelButton="false"
          :customUpload="true"
          :fileLimit="1"
          invalidFileTypeMessage="Ficheiro inválido. Apenas aceita formato CSV"
          @select="onCsvFileSelected"
        >
          <template #empty>
            <div class="drag-drop-files">
              <p>Arraste o ficheiro CSV para aqui ou clique em Selecionar Ficheiro CSV</p>
            </div>
          </template>
        </FileUpload>
        <div v-if="csvImportDialog.file" class="p-mt-2">
          <strong>Ficheiro selecionado:</strong> {{ csvImportDialog.file.name }} ({{ (csvImportDialog.file.size / 1024).toFixed(1) }} KB)
        </div>
        <div v-if="csvImportDialog.result" class="p-mt-3">
          <div class="p-p-3" style="background: #f8f9fa; border-radius: 6px; border: 1px solid #dee2e6;">
            <h5 class="p-mb-2">Estado da Importação:</h5>
            <p class="p-m-0"><strong>Linhas processadas:</strong> {{ csvImportDialog.result.processed || 0 }}/{{ csvImportDialog.result.total || 0 }}</p>
            <p class="p-m-0 text-green-500"><strong>Equipamentos criados:</strong> {{ csvImportDialog.result.created }}</p>
            <p class="p-m-0" style="color: #0288d1;"><strong>Equipamentos atualizados:</strong> {{ csvImportDialog.result.updated }}</p>
            <p class="p-m-0" v-if="csvImportDialog.result.lg_imports_queued > 0" style="color: #0288d1;">
              <strong>Importações LG em fila:</strong> {{ csvImportDialog.result.lg_imports_queued }}
            </p>
            <p class="p-m-0" v-if="csvImportDialog.result.skipped > 0" style="color: #6c757d;"><strong>Linhas ignoradas:</strong> {{ csvImportDialog.result.skipped }}</p>
            <p class="p-m-0 text-red-400" v-if="csvImportDialog.result.last_error">
              <strong>Erro:</strong> {{ csvImportDialog.result.last_error }}
            </p>
            <div v-if="csvImportDialog.result.errors && csvImportDialog.result.errors.length > 0" class="p-mt-2 text-red-400">
              <strong>Erros / Avisos:</strong>
              <ul class="p-pl-3 p-m-0" style="max-height: 120px; overflow-y: auto;">
                <li v-for="(err, idx) in csvImportDialog.result.errors" :key="idx">{{ err }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          label="Importar"
          icon="pi pi-upload"
          class="p-button-sm p-button-success"
          @click="submitCsvImport"
          :disabled="!csvImportDialog.file || csvImportDialog.loading"
        />
        <Button
          label="Fechar"
          icon="pi pi-times"
          class="p-button-sm p-button-danger"
          @click="closeCsvImportDialog"
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import "vue-loading-overlay/dist/vue-loading.css";
import sparsService from "../../services/spars.service.js";
import AuthenticatedImage from "../../components/elements/AuthenticatedImage.vue";
import EquipmentProductsDialog from "../../components/equipaments/EquipmentProductsDialog.vue";
import ImportProducts from "../../components/equipaments/ImportProducts.vue";
import BulkImageManager from "../../components/equipaments/BulkImageManager.vue";
import DebouncedFilterInput from "@/components/elements/DebouncedFilterInput.vue";
import { FilterMatchMode } from "primevue/api";
export default {
  name: "SparsEquipaments",
  components: {
    AuthenticatedImage,
    EquipmentProductsDialog,
    ImportProducts,
    BulkImageManager,
    DebouncedFilterInput,
  },
  data() {
    return {
      loading: false,
      equipmentsList: [],
      selectedEquipments: [],
      totalRecords: 0,
      perPage: 25,
      productsDialog: {
        show: false,
        equipament: null,
      },
      importDialog: {
        show: false,
        equipament: null,
      },
      bulkImageManager: {
        show: false,
      },
      csvImportDialog: {
        show: false,
        loading: false,
        file: null,
        result: null,
      },
      csvImportBatch: {
        storageKey: "sparsEquipment.csvImportBatchId",
        id: null,
        status: null,
        timer: null,
        cancelling: false,
      },
      has_api_id: null,
      brandsList: [],
      suppliersList: [],
      currentPage: 1,
      categoriesList: [],
      categoryDialog: {
        show: false,
        selectedKey: {},
        tempSelectedNode: null,
      },
      form: {
        show: false,
        id: null,
        brand_id: null,
        brand_name: null,
        supplier_id: null,
        spares_category_id: null,
        equipment_series: null,
        model_code: null,
        model_name: null,
        description: null,
        active: null,
      },
      filters: {
        brand_id: { value: null, matchMode: FilterMatchMode.EQUALS },
        supplier_id: { value: null, matchMode: FilterMatchMode.EQUALS },
        category: { value: null, matchMode: FilterMatchMode.CONTAINS },
        model_code: { value: null, matchMode: FilterMatchMode.CONTAINS },
        equipment_series: { value: null, matchMode: FilterMatchMode.CONTAINS },
        model_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        description: { value: null, matchMode: FilterMatchMode.CONTAINS },
        active: { value: null, matchMode: FilterMatchMode.EQUALS },
      },
      bulkDeleteBatch: {
        id: null,
        status: null,
        pollTimer: null,
        inFlight: false,
        cancelling: false,
      },
      destroyed: false,
    };
  },

  computed: {
    csvImportBatchActive() {
      return Boolean(
        this.csvImportBatch.id &&
        (!this.csvImportBatch.status ||
          (!this.csvImportBatch.status.finished && !this.csvImportBatch.status.cancelled))
      );
    },
    bulkDeleteBatchActive() {
      return Boolean(
        this.bulkDeleteBatch.id &&
        (!this.bulkDeleteBatch.status ||
          (!this.bulkDeleteBatch.status.finished && !this.bulkDeleteBatch.status.cancelled))
      );
    },
    categoriesTree() {
      return this.buildTree(this.categoriesList);
    },
    selectedCategoryName() {
      if (!this.form.spares_category_id) return "";
      const cat = this.categoriesList.find(c => c.id === this.form.spares_category_id);
      return cat ? cat.name : "Categoria desconhecida";
    },
    csvImportBatchStatusLabel() {
      const status = this.csvImportBatch.status;
      if (!status) return "";
      if (status.cancelled) {
        return `CSV cancelado: ${status.row_processed || 0}/${status.row_total || 0} linhas`;
      }
      if (status.phase === "queued") {
        return "CSV em fila";
      }
      if (status.phase === "processing") {
        return `CSV: ${status.row_processed || 0} linhas processadas`;
      }
      if (status.phase === "failed") {
        return "Importação CSV falhou";
      }
      if (!status.finished) {
        return `CSV concluído; LG: ${status.successful_jobs}/${status.total_jobs} tarefas concluídas`;
      }
      if (status.failed_jobs > 0) {
        return `Importação concluída com ${status.failed_jobs} falha(s)`;
      }
      return `Importação concluída: ${status.created} criados, ${status.updated} atualizados`;
    },
    csvImportBatchStatusClass() {
      const status = this.csvImportBatch.status;
      if (status && status.cancelled) return "csv-import-status-failed";
      if (!status || !status.finished) return "csv-import-status-pending";
      return status.failed_jobs > 0
        ? "csv-import-status-failed"
        : "csv-import-status-completed";
    },
    bulkDeleteBatchStatusClass() {
      const status = this.bulkDeleteBatch.status;
      if (!status) {
        return "";
      }
      if (status.cancelled) {
        return "bulk-delete-status-failed";
      }
      if (!status.finished) {
        return "bulk-delete-status-pending";
      }
      if (status.failed_jobs > 0) {
        return "bulk-delete-status-failed";
      }
      return "bulk-delete-status-completed";
    },
    bulkDeleteBatchStatusLabel() {
      const status = this.bulkDeleteBatch.status;
      if (!status) {
        return "";
      }
      if (status.cancelled) {
        return `Eliminação cancelada: ${status.deleted_entities || 0}/${status.requested_entities || 0} equipamentos`;
      }
      if (!status.finished) {
        return `Eliminados: ${status.deleted_entities || 0}/${status.requested_entities || 0}; loja: ${status.processed_jobs}/${status.total_jobs}`;
      }
      if (status.failed_jobs > 0) {
        return `Eliminação: ${status.deleted_entities || 0}/${status.requested_entities || 0} (${status.failed_jobs} tarefas falharam)`;
      }
      return `Eliminação concluída: ${status.deleted_entities || 0}/${status.requested_entities || 0} equipamentos`;
    },
  },
  async created() {
    this.loading = true;
    await this.loadEquipments(1);
    this.brandsList = await sparsService.getBrandsByStatus(1);
    this.suppliersList = await sparsService.getSuppliersByStatus(1);
    this.categoriesList = await sparsService.getCategories() || [];
    this.restoreCsvImportBatch();
    this.restoreBulkDeleteBatch();
    this.loading = false;
  },
  deactivated() {
    this.hideForm();
    if (this.categoryDialog) this.categoryDialog.show = false;
    if (this.productsDialog) this.productsDialog.show = false;
    if (this.importDialog) this.importDialog.show = false;
    if (this.csvImportDialog) this.closeCsvImportDialog();
    if (this.bulkImageManager) this.bulkImageManager.show = false;
    document.body.classList.remove('p-overflow-hidden');
  },
  beforeDestroy() {
    this.destroyed = true;
    this.clearCsvImportBatchTimer();
    this.stopBulkDeleteBatchPolling();
    document.body.classList.remove('p-overflow-hidden');
  },
  methods: {
    restoreCsvImportBatch() {
      try {
        const batchId = localStorage.getItem(this.csvImportBatch.storageKey);
        if (batchId) {
          this.csvImportBatch.id = batchId;
          this.loadCsvImportBatchStatus();
        }
      } catch (error) {
        console.error(error);
      }
    },
    clearCsvImportBatchTimer() {
      if (this.csvImportBatch.timer) {
        clearTimeout(this.csvImportBatch.timer);
        this.csvImportBatch.timer = null;
      }
    },
    scheduleCsvImportBatchPoll() {
      this.clearCsvImportBatchTimer();
      if (this.csvImportBatch.status &&
          !this.csvImportBatch.status.finished &&
          !this.csvImportBatch.status.cancelled) {
        this.csvImportBatch.timer = setTimeout(
          () => this.loadCsvImportBatchStatus(),
          5000
        );
      }
    },
    async loadCsvImportBatchStatus() {
      if (!this.csvImportBatch.id) return;

      this.clearCsvImportBatchTimer();
      try {
        const status = await sparsService.getEquipmentCsvImportBatch(
          this.csvImportBatch.id
        );
        if (status) {
          this.csvImportBatch.status = status;
          this.csvImportDialog.result = {
            total: status.row_total,
            processed: status.row_processed,
            created: status.created,
            updated: status.updated,
            skipped: status.skipped,
            lg_imports_queued: status.lg_imports_queued,
            errors: status.errors || [],
            last_error: status.last_error,
          };
          this.scheduleCsvImportBatchPoll();
          if (status.finished || status.cancelled) {
            localStorage.removeItem(this.csvImportBatch.storageKey);
            await this.loadEquipments(this.currentPage);
            this.brandsList = await sparsService.getBrandsByStatus(1);
            this.suppliersList = await sparsService.getSuppliersByStatus(1);
            this.categoriesList = await sparsService.getCategories() || [];
          }
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.csvImportBatch.id = null;
          this.csvImportBatch.status = null;
          try {
            localStorage.removeItem(this.csvImportBatch.storageKey);
          } catch (storageError) {
            console.error(storageError);
          }
          return;
        }
        this.csvImportBatch.timer = setTimeout(
          () => this.loadCsvImportBatchStatus(),
          5000
        );
      }
    },
    confirmCancelCsvImportBatch() {
      if (!this.csvImportBatchActive || this.csvImportBatch.cancelling) {
        return;
      }
      this.$confirm.require({
        header: "Cancelar Importação CSV",
        message: "Pretende cancelar o processamento do CSV e as importações LG que ainda não começaram? A linha ou tarefa já em execução pode terminar.",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sim, Cancelar",
        acceptClass: "p-button-danger p-button p-component",
        rejectLabel: "Manter",
        rejectClass: "p-button-secondary p-button p-component",
        accept: () => this.cancelCsvImportBatch(),
      });
    },
    async cancelCsvImportBatch() {
      this.csvImportBatch.cancelling = true;
      try {
        await sparsService.cancelEquipmentCsvImportBatch(this.csvImportBatch.id);
        await this.loadCsvImportBatchStatus();
        this.$toast.add({
          severity: "info",
          summary: "Cancelamento solicitado",
          detail: "O processamento pendente da importação foi cancelado.",
          life: 4000,
        });
      } catch (error) {
        const detail = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : "Não foi possível cancelar a importação CSV.";
        this.$toast.add({ severity: "error", summary: "Erro", detail, life: 4000 });
      } finally {
        this.csvImportBatch.cancelling = false;
      }
    },
    trackCsvImportBatch(batchId) {
      this.clearCsvImportBatchTimer();
      this.csvImportBatch.id = batchId;
      this.csvImportBatch.status = null;
      try {
        localStorage.setItem(this.csvImportBatch.storageKey, batchId);
      } catch (error) {
        console.error(error);
      }
      this.loadCsvImportBatchStatus();
    },
    async loadEquipments(event = {}) {
      this.loading = true;

      let page = 1;
      if (typeof event === 'number') {
        page = event;
      } else if (event && typeof event.page === 'number') {
        page = event.page + 1;
      } else {
        page = this.currentPage;
      }

      if (event && event.rows) {
        this.perPage = event.rows;
      }

      const filtersPayload = {
        per_page: this.perPage
      };

      for (let key in this.filters) {
        const filterValue = this.filters[key].value;
        if (filterValue !== null && filterValue !== '') {
          filtersPayload[key] = filterValue;
        }
      }

      if (this.has_api_id !== null) {
        filtersPayload['has_api_id'] = this.has_api_id ? 1 : 0;
      }

      const result = await sparsService.getEquipaments(page, filtersPayload);

      if (result) {
        this.equipmentsList = result.data || [];
        this.totalRecords = result.total || 0;
        this.currentPage = result.current_page || 1;
      } else {
        this.equipmentsList = [];
        this.totalRecords = 0;
        this.currentPage = 1;
      }

      this.loading = false;
    },
    openProductsDialog(equipament) {
      this.productsDialog = {
        show: true,
        equipament: equipament,
      };
    },
    openImportDialog(equipament) {
      this.importDialog = {
        show: true,
        equipament: equipament,
      };
    },
    openCsvImportDialog() {
      this.csvImportDialog = {
        show: true,
        loading: false,
        file: null,
        result: null,
      };
      if (this.$refs.csvFileUpload) {
        this.$refs.csvFileUpload.clear();
      }
    },
    closeCsvImportDialog() {
      this.csvImportDialog.show = false;
      this.csvImportDialog.file = null;
      this.csvImportDialog.result = null;
      if (this.$refs.csvFileUpload) {
        this.$refs.csvFileUpload.clear();
      }
    },
    onCsvFileSelected(event) {
      if (event && event.files && event.files.length > 0) {
        this.csvImportDialog.file = event.files[0];
        this.csvImportDialog.result = null;
      }
    },
    async submitCsvImport() {
      if (!this.csvImportDialog.file) {
        this.$toast.add({
          severity: "warn",
          summary: "Aviso",
          detail: "Por favor selecione um ficheiro CSV",
          life: 3000,
        });
        return;
      }

      this.csvImportDialog.loading = true;
      let formData = new FormData();
      formData.append("file", this.csvImportDialog.file);

      try {
        const response = await sparsService.importEquipmentsCsv(formData);
        this.csvImportDialog.loading = false;
        if (response) {
          if (response.batch_id) {
            this.trackCsvImportBatch(response.batch_id);
          }
          this.$toast.add({
            severity: "info",
            summary: "Importação em fila",
            detail: response.message,
            life: 4000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail: "Erro ao importar ficheiro CSV",
            life: 3000,
          });
        }
      } catch (error) {
        this.csvImportDialog.loading = false;
        const data = error.response && error.response.data ? error.response.data : null;
        let msg = data && data.message
          ? data.message
          : error.message || "Erro ao processar ficheiro CSV";
        if (data && data.missing_headers && data.missing_headers.length > 0) {
          msg += ` Colunas em falta: ${data.missing_headers.join(", ")}.`;
        }
        if (data && data.duplicate_headers && data.duplicate_headers.length > 0) {
          msg += ` Colunas duplicadas: ${data.duplicate_headers.join(", ")}.`;
        }
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: msg,
          life: 4000,
        });
      }
    },
    hideForm() {
      this.$validator.pause();
      this.$validator.reset();
      return (this.form = {
        show: false,
        id: null,
        brand_id: null,
        brand_name: null,
        supplier_id: null,
        spares_category_id: null,
        equipment_series: null,
        model_code: null,
        model_name: null,
        description: null,
        active: null,
      });
    },
    addNew() {
      return (this.form = {
        show: true,
        id: null,
        brand_id: null,
        brand_name: null,
        supplier_id: null,
        spares_category_id: null,
        equipment_series: null,
        model_code: null,
        model_name: null,
        description: null,
        active: true,
      });
    },
    edit(data) {
      this.form = {
        show: true,
        id: data.id,
        brand_id: data.brand_id,
        brand_name: data.brand.name,
        supplier_id: data.supplier_id,
        spares_category_id: data.spares_category_id,
        equipment_series: data.equipment_series,
        model_code: data.model_code,
        model_name: data.model_name,
        description: data.description,
        active: data.active == 1 ? true : false,
        data: data,
      };
    },
    save() {
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          return;
        }
        this.loading = true;
        if (this.form.id) {
          return this.saveEdit();
        }
        return this.saveNew();
      });
    },
    getFormParams() {
      let formData = new FormData();
      formData.append("brand_id", this.form.brand_id);
      formData.append("supplier_id", this.form.supplier_id);
      formData.append("equipment_series", this.form.equipment_series);
      formData.append("model_code", this.form.model_code);
      formData.append("model_name", this.form.model_name);
      formData.append("description", this.form.description);
      formData.append("active", this.form.active ? 1 : 0);
      if (this.form.spares_category_id !== null && this.form.spares_category_id !== undefined) {
        formData.append("spares_category_id", this.form.spares_category_id);
      }
      if (
        this.$refs.imagesLocation != undefined &&
        this.$refs.imagesLocation.files.length > 0
      ) {
        formData.append(
          "localization_parts",
          this.$refs.imagesLocation.files[0]
        );
      }
      if (
        this.$refs.images != undefined &&
        this.$refs.images.files.length > 0
      ) {
        this.$refs.images.files.forEach((file) => {
          formData.append("images[]", file);
        });
      }
      return formData;
    },
    saveNew() {
      this.loading = true;

      return sparsService
        .newEquipaments(this.getFormParams())
        .then(async (response) => {
          this.loading = false;
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: "Erro ao adicionar equipamento",
              life: 3000,
            });
          }
          await this.loadEquipments(this.currentPage);
          this.$toast.add({
            severity: "success",
            summary: "Sucesso",
            detail: "Equipamento adicionada com sucesso",
            life: 3000,
          });
          return this.hideForm();
        });
    },
    saveEdit() {
      this.loading = true;
      return sparsService
        .updateEquipaments(this.form.id, this.getFormParams())
        .then(async (response) => {
          this.loading = false;
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: "Erro ao atualizar equipamento",
              life: 3000,
            });
          }
          await this.loadEquipments(this.currentPage);
          this.$toast.add({
            severity: "success",
            summary: "Sucesso",
            detail: "Equipamento atualizada com sucesso",
            life: 3000,
          });
          return this.hideForm();
        });
    },
    removeImage(file, from) {
      this.$confirm.require({
        key: "dialogRemoveEquipmentFile",
        header: "Remover Ficheiro",
        message: `Tem a certeza que pretende remover o ficheiro ${file.file_origin_name}?`,
        icon: "pi pi-question-circle",
        acceptLabel: "Sim",
        acceptIcon: "pi pi-check",
        acceptClass: "p-button-success p-button p-component",
        rejectLabel: "Não",
        rejectIcon: "pi pi-times",
        rejectClass: "p-button-danger p-button p-component",
        accept: () => {
          return sparsService
            .removeEquipmentFile(this.form.id, file.id)
            .then((response) => {
              if (!response) {
                return this.$toast.add({
                  severity: "error",
                  summary: "Erro",
                  detail: "Ocorreu um erro ao remover o ficheiro.",
                });
              }
              if (from == "localization") {
                this.form.data.localization_parts_file.splice(
                  this.form.data.localization_parts_file.findIndex(
                    (f) => f.id === file.id
                  ),
                  1
                );
              } else {
                this.form.data.images.splice(
                  this.form.data.images.findIndex((f) => f.id === file.id),
                  1
                );
              }
            });
        },
        reject: () => {
          return;
        },
      });
    },
    syncToStore() {
      this.loading = true;
      return sparsService.syncProductsStore().then(async (response) => {
        this.loading = false;
        await this.loadEquipments(this.currentPage);
        if (!response) {
          return this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail: "Erro ao sincronizar produtos com a loja",
            life: 3000,
          });
        }
        this.$toast.add({
          severity: "success",
          summary: "Sucesso",
          detail: "Produtos sincronizados com sucesso",
          life: 3000,
        });

      }).catch(async (err) => {
        this.loading = false;
        console.log(err)
        await this.loadEquipments(this.currentPage);
      });
    },
    syncImagesToStore() {
      this.loading = true;
      return sparsService.syncImagesEquipmentsStore().then(async (response) => {
        this.loading = false;
        await this.loadEquipments(this.currentPage);
        if (!response) {
          return this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail: "Erro ao sincronizar produtos com a loja",
            life: 3000,
          });
        }
        this.$toast.add({
          severity: "success",
          summary: "Sucesso",
          detail: "Produtos sincronizados com sucesso",
          life: 3000,
        });

      }).catch(async (err) => {
        this.loading = false;
        console.log(err)
        await this.loadEquipments(this.currentPage);
      });
    },
    confirmDelete(equipment) {
      this.$confirm.require({
        header: "Eliminar Equipamento",
        message: `Tem a certeza que pretende eliminar o equipamento "${equipment.model_code}"? Esta ação irá remover o equipamento, as imagens e a categoria correspondente na loja.`,
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sim, Eliminar",
        acceptIcon: "pi pi-trash",
        acceptClass: "p-button-danger p-button p-component",
        rejectLabel: "Cancelar",
        rejectIcon: "pi pi-times",
        rejectClass: "p-button-secondary p-button p-component",
        accept: async () => {
          this.loading = true;
          try {
            const res = await sparsService.deleteEquipment(equipment.id);
            if (res) {
              this.$toast.add({
                severity: "success",
                summary: "Sucesso",
                detail: "Equipamento eliminado com sucesso",
                life: 3000,
              });
              this.selectedEquipments = this.selectedEquipments.filter(e => e.id !== equipment.id);
              await this.loadEquipments(this.currentPage);
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Erro",
                detail: "Erro ao eliminar equipamento",
                life: 3000,
              });
            }
          } catch (err) {
            console.error(err);
            this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: "Erro ao eliminar equipamento",
              life: 3000,
            });
          } finally {
            this.loading = false;
          }
        },
      });
    },
    restoreBulkDeleteBatch() {
      const savedBatchId = localStorage.getItem("spars_equipment_bulk_delete_batch_id");
      if (savedBatchId) {
        this.bulkDeleteBatch.id = savedBatchId;
        this.loadBulkDeleteBatchStatus();
      }
    },
    stopBulkDeleteBatchPolling() {
      if (this.bulkDeleteBatch.pollTimer) {
        clearTimeout(this.bulkDeleteBatch.pollTimer);
        this.bulkDeleteBatch.pollTimer = null;
      }
    },
    confirmCancelBulkDeleteBatch() {
      if (!this.bulkDeleteBatchActive || this.bulkDeleteBatch.cancelling) {
        return;
      }
      this.$confirm.require({
        header: "Cancelar Eliminação",
        message: "Pretende cancelar os equipamentos que ainda não começaram a ser eliminados? O trabalho já em execução pode terminar.",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sim, Cancelar",
        acceptClass: "p-button-danger p-button p-component",
        rejectLabel: "Manter",
        rejectClass: "p-button-secondary p-button p-component",
        accept: () => this.cancelBulkDeleteBatch(),
      });
    },
    async cancelBulkDeleteBatch() {
      this.bulkDeleteBatch.cancelling = true;
      try {
        await sparsService.cancelEquipmentBulkDeleteBatch(this.bulkDeleteBatch.id);
        await this.loadBulkDeleteBatchStatus();
        this.$toast.add({
          severity: "info",
          summary: "Cancelamento solicitado",
          detail: "Os equipamentos ainda não iniciados não serão eliminados.",
          life: 4000,
        });
      } catch (error) {
        const detail = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : "Não foi possível cancelar a eliminação em lote.";
        this.$toast.add({ severity: "error", summary: "Erro", detail, life: 4000 });
      } finally {
        this.bulkDeleteBatch.cancelling = false;
      }
    },
    async loadBulkDeleteBatchStatus() {
      if (!this.bulkDeleteBatch.id || this.bulkDeleteBatch.inFlight || this.destroyed) {
        return;
      }
      const batchId = this.bulkDeleteBatch.id;
      this.bulkDeleteBatch.inFlight = true;
      try {
        const status = await sparsService.getEquipmentBulkDeleteBatch(batchId);
        if (this.destroyed || this.bulkDeleteBatch.id !== batchId) {
          return;
        }
        this.bulkDeleteBatch.status = status;

        if (!status.finished && !status.cancelled) {
          this.stopBulkDeleteBatchPolling();
          this.bulkDeleteBatch.pollTimer = setTimeout(() => {
            this.loadBulkDeleteBatchStatus();
          }, 2500);
        } else {
          this.stopBulkDeleteBatchPolling();
          localStorage.removeItem("spars_equipment_bulk_delete_batch_id");
          await this.loadEquipments(this.currentPage);
          const failedIds = status.failed_entity_ids || [];
          this.selectedEquipments = this.selectedEquipments.filter(equipment => failedIds.includes(equipment.id));
          if (status.cancelled) {
            this.$toast.add({
              severity: "info",
              summary: "Eliminação cancelada",
              detail: `${status.deleted_entities || 0} de ${status.requested_entities || 0} equipamento(s) foram eliminados.`,
              life: 5000,
            });
          } else if (status.failed_jobs > 0) {
            this.$toast.add({
              severity: "warn",
              summary: "Eliminação em lote terminada",
              detail: `${status.deleted_entities || 0} equipamento(s) eliminado(s), ${status.failed_jobs} tarefa(s) de loja falharam. IDs locais restantes: ${failedIds.join(", ") || "nenhum"}.`,
              life: 5000,
            });
          } else {
            this.$toast.add({
              severity: "success",
              summary: "Eliminação concluída",
              detail: `${status.deleted_entities || 0} equipamento(s) eliminado(s) e loja reconciliada com sucesso.`,
              life: 4000,
            });
          }
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.stopBulkDeleteBatchPolling();
          localStorage.removeItem("spars_equipment_bulk_delete_batch_id");
          this.bulkDeleteBatch.id = null;
          this.bulkDeleteBatch.status = null;
          return;
        }
        if (!this.destroyed && this.bulkDeleteBatch.id === batchId) {
          this.stopBulkDeleteBatchPolling();
          this.bulkDeleteBatch.pollTimer = setTimeout(() => {
            this.loadBulkDeleteBatchStatus();
          }, 5000);
        }
      } finally {
        this.bulkDeleteBatch.inFlight = false;
      }
    },
    confirmBulkDelete() {
      if (this.bulkDeleteBatchActive) {
        return;
      }
      const count = this.selectedEquipments.length;
      this.$confirm.require({
        header: "Eliminar Equipamentos Selecionados",
        message: `Tem a certeza que pretende colocar ${count} equipamento(s) na fila de eliminação? Os equipamentos serão removidos com as respetivas fotos, associações aos produtos e categorias da loja em segundo plano.`,
        icon: "pi pi-exclamation-triangle",
        acceptLabel: `Sim, Eliminar (${count})`,
        acceptIcon: "pi pi-trash",
        acceptClass: "p-button-danger p-button p-component",
        rejectLabel: "Cancelar",
        rejectIcon: "pi pi-times",
        rejectClass: "p-button-secondary p-button p-component",
        accept: async () => {
          this.loading = true;
          try {
            const ids = this.selectedEquipments.map(e => e.id);
            const result = await sparsService.bulkDeleteEquipments(ids);

            this.bulkDeleteBatch.id = result.batch_id;
            localStorage.setItem("spars_equipment_bulk_delete_batch_id", result.batch_id);

            this.$toast.add({
              severity: "info",
              summary: "Em fila de processamento",
              detail: result.message || `${count} equipamentos colocados em fila para eliminação.`,
              life: 4000,
            });

            await this.loadBulkDeleteBatchStatus();
          } catch (error) {
            const detail = error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : "Erro ao iniciar eliminação em lote de equipamentos";
            this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail,
              life: 4000,
            });
          } finally {
            this.loading = false;
          }
        },
      });
    },
    buildTree(list) {
      const map = {};
      const roots = [];

      list.forEach((item) => {
        map[item.id] = {
          key: String(item.id),
          label: item.name,
          data: item,
          children: []
        };
      });

      list.forEach((item) => {
        const mapped = map[item.id];
        if (item.parent_id && map[item.parent_id]) {
          map[item.parent_id].children.push(mapped);
        } else {
          roots.push(mapped);
        }
      });

      const clearEmptyChildren = (node) => {
        if (node.children.length === 0) {
          delete node.children;
        } else {
          node.children.forEach(clearEmptyChildren);
        }
      };

      roots.forEach(clearEmptyChildren);
      return roots;
    },
    showCategoryDialog() {
      const selectedId = this.form.spares_category_id;
      if (selectedId) {
        this.categoryDialog.selectedKey = { [selectedId]: true };
        const found = this.categoriesList.find(c => c.id === selectedId);
        if (found) {
          this.categoryDialog.tempSelectedNode = {
            key: String(found.id),
            label: found.name,
            data: found
          };
        } else {
          this.categoryDialog.tempSelectedNode = null;
        }
      } else {
        this.categoryDialog.selectedKey = {};
        this.categoryDialog.tempSelectedNode = null;
      }
      this.categoryDialog.show = true;
    },
    onCategorySelect(node) {
      this.categoryDialog.tempSelectedNode = node;
    },
    confirmCategorySelection() {
      if (this.categoryDialog.tempSelectedNode) {
        this.form.spares_category_id = parseInt(this.categoryDialog.tempSelectedNode.key);
      }
      this.categoryDialog.show = false;
    },
    clearSelectedCategory() {
      this.form.spares_category_id = null;
    },
  },
};
</script>
<style>
.drag-drop-files {
  border: 2px dashed #ccc;
  border-radius: 4px;
  padding: 20px;
  text-align: center;
  margin-top: 10px;
}

.text-red-400 {
    color: rgb(248 113 113 / 1);
}

.text-green-500 {
  color: rgb(34 197 94 / 1);
}

.category-node {
  padding: 6px 12px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.category-node:hover {
  background-color: #f3f4f6;
  color: #007bff;
}

.category-node-selected {
  background-color: #007bff !important;
  color: #ffffff !important;
  font-weight: 600;
  box-shadow: 0 4px 6px -1px rgba(79, 70, 229, 0.2), 0 2px 4px -1px rgba(79, 70, 229, 0.1);
}

.category-node-selected i {
  color: #ffffff !important;
}

.csv-import-status {
  display: inline-flex;
  align-items: center;
  border-radius: 12px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.35rem 0.65rem;
}

.csv-import-status-pending {
  background: #fff3cd;
  color: #856404;
}

.csv-import-status-completed {
  background: #d4edda;
  color: #155724;
}

.csv-import-status-failed {
  background: #f8d7da;
  color: #721c24;
}

.bulk-delete-status {
  display: inline-flex;
  align-items: center;
  border-radius: 12px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.35rem 0.65rem;
}

.bulk-delete-status-pending {
  background: #fff3cd;
  color: #856404;
}

.bulk-delete-status-completed {
  background: #d4edda;
  color: #155724;
}

.bulk-delete-status-failed {
  background: #f8d7da;
  color: #721c24;
}

.p-datatable .p-datatable-tbody > tr.p-highlight {
    background: #dedede;
    color: #000000;
}

</style>
